// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5j-0";
export var startPickingButton = "_5j-1";